export default __webpack_public_path__ + "static/media/swallow.d33eaa05.jpg";